<template>
  <div id="main">

    <el-container style="height: 100%;">
      <el-header  id="top" style="background-color: #409EFF; ">
        <el-row style="line-height: 60px; color:#FFF;">
          <div style="float: left; margin-right: 10px">
            <span class="el-icon-menu" style="font-size:20pt;"></span> <span style="font-size: 20pt">小度订单助手</span>

          </div>
          <div style="float: left; margin-right: 10px; display: none">
            <span class="el-icon-menu" style="font-size:20pt;"></span> <span style="font-size: 20pt">小度订单助手</span>
            <span  style="margin-left:200px; font-size: 16pt">【重要】续费提醒二</span>
            <el-image :src="go" style="width: 50px;vertical-align: middle;cursor:pointer ;" @click="showAd=true"></el-image>
          </div>

          <!--<div  style="float: right; margin-right: 20px">
            <a href="http://www.taobao.com/webww/ww.php?ver=3&touid=wgaofa&siteid=cntaobao&status=1&charset=utf-8"
               target="_blank"><img style="vertical-align: middle" alt="点这里给我发消息" border="0" src="http://amos.alicdn.com/online.aw?v=2&uid=wgaofa&site=cntaobao&s=1&charset=utf-8"></a>
          </div>-->
          <div  style="float: right; margin-right: 20px;vertical-align: middle">
            <a href="http://www.taobao.com/webww/ww.php?ver=3&touid=wgaofa&siteid=cntaobao&status=1&charset=utf-8"
               target="_blank"><el-image style="vertical-align: middle; margin-top: 20px" alt="点这里给我发消息" border="0" :src="wang"></el-image></a>
          </div>
          <div  style="float: right; margin-right: 20px; font-size:10pt">
            <span>【{{version}}】 {{deadline}} </span>
            <el-link style="color:#FFF; text-decoration:none;" target="_blank" href="https://fuwu.taobao.com/ser/detail.htm?service_code=ts-24407">续费</el-link>
          </div>
          <div  style="float: right; margin-right: 20px;font-size:10pt">
            <div v-if="logined" ><span  class="el-icon-user-solid"></span><span v-if="true">【{{username}}】</span>
              <el-link style="color:#FFF;text-decoration:none;"  @click="logout">退出</el-link>
            </div>
            <div v-else="logined" class="login">
              <el-link style="color:#FFF;font-size: 12pt; text-decoration:none;" @click="login">Login</el-link>
            </div>
          </div>

          <div style="float: right; margin-right: 20px;font-size: 10pt;">
            <el-dropdown @command="changeShop" >
                <span class="el-dropdown-link" style="color:#FFF;">
                  切换店铺<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item,index) in users" v-text="item.bindNick" :key="item.bindNick" :command="item.bindNick"></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-row>
      </el-header>

      <el-container >
        <el-aside width="200px"  id="left" style="height: 100%;">
          <el-menu
            @select="handleSelect"
            @open="handleOpen"
            :collapse="false"
            :default-openeds="openKeys"
            :default-active="active"
            class="el-menu-vertical-demo1"
            style="font-size: 20px;height: 100%;"
          >

            <el-menu-item index="1">
              <i class="el-icon-s-home"></i>
              <span slot="title">首 页</span>
            </el-menu-item>


            <el-submenu index="G5">
              <template slot="title">
                <i class="el-icon-printer"></i>
                <span>打单发货</span>
              </template>
              <el-menu-item index="15">
                <i class="el-icon-tickets"></i>
                <span slot="title">快递模板</span>
              </el-menu-item>
              <el-menu-item index="16">
                <i class="el-icon-tickets"></i>
                <span slot="title">打单发货</span>
              </el-menu-item>
              <el-menu-item index="17">
                <i class="el-icon-tickets"></i>
                <span slot="title">自由打单</span>
              </el-menu-item>
            </el-submenu>


            <el-submenu index="G1">
              <template slot="title">
                <i class="el-icon-shopping-cart-full"></i>
                <span>订单管理</span>
              </template>
              <el-menu-item index="2">
                <i class="el-icon-tickets"></i>
                <span slot="title">同步订单</span>
              </el-menu-item>
              <el-menu-item index="3">
                <i class="el-icon-tickets"></i>
                <span slot="title">查看订单</span>
              </el-menu-item>


              <el-menu-item index="13">
                <i class="el-icon-tickets"></i>
                <span slot="title">导入数据</span>
              </el-menu-item>
              <el-menu-item index="7">
                <i class="el-icon-tickets"></i>
                <span slot="title">配货统计</span>
              </el-menu-item>
              <el-menu-item index="9">
                <i class="el-icon-tickets"></i>
                <span slot="title">定制功能</span>
              </el-menu-item>

            </el-submenu>



            <el-submenu index="G2">
              <template slot="title">
                <i class="el-icon-truck"></i>
                <span>批量操作</span>
              </template>
              <el-menu-item index="4">
                <i class="el-icon-tickets"></i>
                <span slot="title">批量发货</span>
              </el-menu-item>
              <el-menu-item index="5">
                <i class="el-icon-tickets"></i>
                <span slot="title">批量备注</span>
              </el-menu-item>
              <el-menu-item index="6">
                <i class="el-icon-tickets"></i>
                <span slot="title">延长收货</span>
              </el-menu-item>
              <el-menu-item index="30">
                <i class="el-icon-tickets"></i>
                <span slot="title">批量退款</span>
              </el-menu-item>
              <!--<el-menu-item index="19">
                <i class="el-icon-tickets"></i>
                <span slot="title">批量关闭</span>
              </el-menu-item>-->
            </el-submenu>

            <el-submenu index="G3">
              <template slot="title">
                <i class="el-icon-reading"></i>
                <span>商品管理</span>
              </template>
              <el-menu-item index="8">
                <i class="el-icon-tickets"></i>
                <span slot="title">商品管理</span>
              </el-menu-item>
<!--              <el-menu-item index="80">
                <i class="el-icon-tickets"></i>
                <span slot="title">本地商品</span>
              </el-menu-item>-->
            </el-submenu>

            <el-submenu index="G4">
              <template slot="title">
                <i class="el-icon-set-up"></i>
                <span>店铺设置</span>
              </template>
              <el-menu-item index="10">
                <i class="el-icon-tickets"></i>
                <span slot="title">店铺绑定</span>
              </el-menu-item>
              <el-menu-item index="11">
                <i class="el-icon-tickets"></i>
                <span slot="title">权限管理</span>
              </el-menu-item>
              <el-menu-item index="14">
                <i class="el-icon-tickets"></i>
                <span slot="title">修改sku</span>
              </el-menu-item>
            </el-submenu>

            <el-submenu index="G6">
              <template slot="title">
                <i class="el-icon-set-up"></i>
                <span>自动发货</span>
              </template>
              <el-menu-item index="90">
                <i class="el-icon-tickets"></i>
                <span slot="title">自动发货</span>
              </el-menu-item>
<!--              <el-menu-item index="91">
                <i class="el-icon-tickets"></i>
                <span slot="title">备注信息</span>
              </el-menu-item>-->
<!--              <el-menu-item index="92">
                <i class="el-icon-tickets"></i>
                <span slot="title">商品信息</span>
              </el-menu-item>-->
            </el-submenu>

            <el-submenu index="G7">
              <template slot="title">
                <i class="el-icon-set-up"></i>
                <span>自动备注</span>
              </template>
              <el-menu-item index="93">
                <i class="el-icon-tickets"></i>
                <span slot="title">自动备注</span>
              </el-menu-item>
            </el-submenu>





            <el-menu-item index="12">
              <i class="el-icon-tickets"></i>
              <span slot="title">使用帮助</span>
            </el-menu-item>


          </el-menu>

        </el-aside>
        <el-main>
          <div style="height: 5px;"></div>
          <router-view ></router-view>
        </el-main>
      </el-container>

    </el-container>


    <el-dialog
      title="续费提醒二"
      :visible.sync="showAd"
      width="650px"
      center>

      <p> <span style="font-size:14pt; color:red">6月16日 - 7月31日 期间无法续费</span>  </p>
      <p> <span style="font-size:14pt; color:red">请到期时间在60天以内的用户及时续费， </span> <span style="font-size:16pt; color:red; font-weight: bold">建议续费3个月 </span> </p>

      <p> <span style="font-size:16pt; color:red">【到期时间】{{deadline}} </span> </p>
      <p>
        <el-link  style="font-size: 20px" type="primary" target="_blank" href="https://fuwu.taobao.com/ser/detail.htm?service_code=ts-24407">
          续费链接</el-link> </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showAd = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import $api from "../api/axios";
  import storage from "../api/storage"

export default {

  data() {
    return {
      active: '1',
      username: '未登录',
      logined:true,
      days:0,
      deadline:'',
      version:'基础版',
      users:[],
      changeNick:'',
      display:1,
      icon:'el-icon-d-arrow-left',
      name:'隐藏菜单',
      go:'./static/image/GO.gif',
      showAd:false,
      wang: './static/image/wang.gif',
      openKeys:[],
    };
  },
  methods: {
    hideLeft(){
      this.display++;
      if(this.display % 2 == 0){
        window.document.getElementById("left").style.display = 'none';
        this.icon = 'el-icon-d-arrow-right'
        this.name = '显示菜单'
      }else {
        window.document.getElementById("left").style.display = 'block';
        this.icon = 'el-icon-d-arrow-left'
        this.name = '隐藏菜单'
      }
    },
    changeShop:function(changeNick){
      /*this.changeNick =  changeNick;
      this.username = changeNick;
      storage.set("nick", changeNick);*/
      let param = {
        nick: storage.get("nick"),
        subNick:storage.get("subnick"),
        changeNick: changeNick,
      }
      $api.post("/changeShop", param, response =>{
        let dataResult = response.data;
        if (dataResult.state == 1 && dataResult.message == "ok") {
          storage.set("nick", dataResult.data.nick);
          storage.set("subnick", dataResult.data.subnick);
          storage.set("days",dataResult.data.days);
          storage.set("token", dataResult.data.token);
          //新登录 清除上次保存的时间
          storage.remove("created");
          this.$router.replace({name: 'Login'});
        }else{
          this.$message({
            type: 'error',
            message: '抱歉，'+dataResult.message
          })
        }
      });
    },
    handleSelect:function (index) {
      storage.set("active",index);

      switch (index) {
        case "1":
          this.$router.replace({name: 'Index'});
          break;
        case "2":
          this.$router.push({name: 'ShowSet'});
          break;
        case "3":
          this.$router.push({name: 'ShowData'});
          break;
        case "4":
          this.$router.push({name: 'Logistics'});
          break;
        case "5":
          this.$router.push({name: 'SellerMemo'});
          break;
        case "6":
          this.$router.push({name: 'Delay'});
          break;
        case "7":
          this.$router.push({name: 'BeiHuo'});
          break;
        case "8":
          this.$router.push({name: 'Item'});
          break;
        case "9":
          this.$router.push({name: 'Custom'});
          break;
        case "10":
          this.$router.push({name: 'Bind'});
          break;
        case "11":
          this.$router.push({name: 'Permission'});
          break;
        case "12":
          this.$router.push({name: 'Help'});
          break;
        case "13":
          this.$router.push({name: 'Outer'});
          break;
        case "14":
          this.$router.push({name: 'ModiSku'});
          break;
        case "15":
          this.$router.push({name: 'KddTemp'});
          break;
        case "16":
          this.$router.push({name: 'Print'});
          break;
        case "17":
          this.$router.push({name: 'Free'});
          break;
        case "18":
          this.$router.push({name: 'Address'});
          break;
        case "19":
          this.$router.push({name: 'ShowPrint'});
          break;
        case "30":
          this.$router.push({name: 'Refund'});
          break;
        case "90":
          this.$router.push({name: 'AutoSend'});
          break;
        case "91":
          this.$router.push({name: 'MemoLog'});
          break;
        case "92":
          this.$router.push({name: 'SendItem'});
          break;
        case "93":
          this.$router.push({name: 'AutoMemo'});
          break;

      }


    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
      this.openKeys = [key];
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    login(){
      this.logined = true;
    },
    logout(){
      storage.remove("nick");
      storage.remove("subnick");
      storage.remove("token");
      storage.remove("days");
      this.$router.replace({name: 'Login'})
      this.logined = false;
    },
    getShopBind: function(){
      let param={
        nick: storage.get("nick"),
        subNick:storage.get("subnick")
      }
      $api.post("/getShop", param,response=> {
        console.log(response.data)
        let dataResult = response.data;
        if (dataResult.state == "1" && dataResult.message == "ok") {
          this.users = dataResult.data
        } else {
          this.$message.error(dataResult.message);
        }
      })
    },
    getVersion:function(){
      let param={
        nick:storage.get("nick")
      }
      $api.post("/getVersion", param,response=>{
        console.log(response.data)
        let dataResult = response.data;
        if(dataResult.state=="1" && dataResult.message == "ok"){
          let version = dataResult.data;
          if(version == "0"){
            this.version = "试用版"
          }else if(version == "1"){
            this.version = "基础版"
          }else if(version == "2"){
            this.version = "高级版"
          }else if(version == "3"){
            this.version = "定制版"
          }else if(version == "4"){
            this.version = "自动发货1000单"
          }else if(version == "5"){
            this.version = "自动发货5000单"
          }else if(version == "6"){
            this.version = "自动发货不限量"
          }else{
            this.version = "定制版"
          }
        }else{
          console.log(dataResult.message);
        }
      })
    },
  },
  mounted() {
    //域名跳转
    if(window.location.href.indexOf('www')>=0) {
      this.$confirm('登录信息已过期，请重新登录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        window.location.href = 'https://container.open.taobao.com/container?appkey=12583049';
      }).catch(() => {
        window.location.href = 'https://container.open.taobao.com/container?appkey=12583049';
      });
    }

    let nick = storage.get("nick");
    if(nick == null){
      this.$message.error("您当前没有登录，请登录后进行操作！");
      this.$router.replace({name:"Login"});

    }else {
      this.active = storage.get("active");
      let subnick = storage.get("subnick");
      if (subnick == "")
        this.username = storage.get("nick");
      else
        this.username = storage.get("subnick")
      this.days = storage.get("days");
      this.deadline = storage.get("deadline");
    }
    this.getShopBind();
    this.getVersion();
  }
}
</script>

<style >
  html,body,#app{
    height: 100%;

  }
  .el-main{
    padding-top:0px;
    padding-left: 5px;
  }


  .el-textarea__inner{
    font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }

#main {
  font-family: ‘宋体’,'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  height: 100%;
}


</style>



// WEBPACK FOOTER //
// src/page/Main.vue